"use client";

import React from "react";
import { cn } from "@/lib/utils";
import { Toolbar } from "@/components/common/Toolbar";

interface ChartTradeToolbarProps {
  children: React.ReactNode;
  /** When false, fades out and ignores pointer events (pending-order panel). */
  visible?: boolean;
  className?: string;
  /** Accessible name for the toolbar. */
  ariaLabel?: string;
}

/** Floating chart toolbar shell — matches ChartTradePanel desktopOverlay chrome. */
export function ChartTradeToolbar({
  children,
  visible = true,
  className,
  ariaLabel = "Chart trade toolbar",
}: ChartTradeToolbarProps) {
  return (
    <div
      className={cn(
        "pointer-events-auto absolute bottom-4 left-1/2 z-50 w-max -translate-x-1/2 transition-opacity duration-200",
        visible ? "opacity-100" : "pointer-events-none opacity-0",
        className,
      )}
    >
      <Toolbar
        label={ariaLabel}
        className="flex items-center gap-1 rounded-md border border-border bg-background/90 px-1 py-1 shadow-sm backdrop-blur-sm"
      >
        {children}
      </Toolbar>
    </div>
  );
}

export const chartToolbarBtn =
  "inline-flex h-6 shrink-0 items-center justify-center rounded text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50";

export const chartToolbarBtnOutline =
  `${chartToolbarBtn} border border-input bg-background px-2 text-foreground hover:bg-muted`;

export const chartToolbarBtnGhost =
  `${chartToolbarBtn} w-6 p-0 text-muted-foreground hover:bg-muted hover:text-foreground`;

export const chartToolbarDivider = "mx-0.5 h-4 w-px shrink-0 bg-border";
